module.exports = __webpack_public_path__ + "img/no_Data.3da70a94.png";